import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const Headshot = createSvgIcon(
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2074_7789)">
      <circle cx="16" cy="16" r="7.9375" stroke="currentColor" strokeWidth="2" />
      <rect x="4" y="15" width="24" height="2" fill="currentColor" />
      <rect x="15.5" y="27.5" width="23" height="1" transform="rotate(-90 15.5 27.5)" fill="currentColor" stroke="currentColor" />
    </g>
    <defs>
      <clipPath id="clip0_2074_7789">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>,
  'Headshot'
);
